import { SvgIcon } from '@material-ui/core'

export default function CameraIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 25 24" fill="none" {...props}>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.4593 7.05293C0.992188 7.9697 0.992188 9.16981 0.992188 11.57V12.4272C0.992188 14.8274 0.992188 16.0275 1.4593 16.9443C1.87019 17.7507 2.52582 18.4063 3.33223 18.8172C4.24899 19.2843 5.44911 19.2843 7.84934 19.2843H9.56362C11.9638 19.2843 13.164 19.2843 14.0807 18.8172C14.8871 18.4063 15.5428 17.7507 15.9536 16.9443C16.4208 16.0275 16.4208 14.8274 16.4208 12.4272V11.57C16.4208 9.16981 16.4208 7.9697 15.9536 7.05293C15.5428 6.24652 14.8871 5.59089 14.0807 5.18001C13.164 4.71289 11.9638 4.71289 9.56361 4.71289H7.84933C5.44911 4.71289 4.24899 4.71289 3.33223 5.18001C2.52582 5.59089 1.87019 6.24652 1.4593 7.05293ZM21.4699 8.67625C22.4633 7.97272 23.8368 8.68307 23.8368 9.90036V14.0996C23.8368 15.3169 22.4633 16.0273 21.4699 15.3238L18.5051 13.2241C17.661 12.6263 17.661 11.3737 18.5051 10.7759L21.4699 8.67625Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    )
}
